<template>
  <div>
    <div class="box">
      <el-page-header
        @back="$router.go(-1)"
        :content="$t('tChapterList')"
      ></el-page-header>
    </div>
    <el-card class="mb15 mt20" shadow="hover">
      <el-row>
        <el-input
          :placeholder="$t('search')"
          clearable
          v-model="filter.search"
          @keyup.enter.native="get_list"
        ></el-input>
      </el-row>
      <el-row class="mt20" type="flex" align="middle">
        <el-button @click="get_list" type="primary" class="search">{{
          $t("search_zh")
        }}</el-button>
        <el-button @click="reset" type="info">{{
          $t("btnTip.reset")
        }}</el-button>
      </el-row>
    </el-card>
    <el-card shadow="hover">
      <div class="flexBC mb20">
        <el-button type="primary" @click="handleClick('add')">{{
          $t("btnTip.add")
        }}</el-button>
        <el-button type="primary" @click="outExe">{{ $t("outExe") }}</el-button>
      </div>
      <my-table
        :columns="columns"
        :data="list_data.list"
        :showIndex="false"
        :showSelection="false"
        :cellStyle="{ padding: '6px 0' }"
        :headerCellStyle="{
          background: 'rgba(51, 55, 68, 1)',
          color: '#fff',
        }"
        @emitSelection="allSelect"
        @sortChange="sort_change"
      >
      <!-- <template v-slot:is_free="slotProps">
          <el-tag :type="is_freeTag(slotProps.callback.row.is_free)">
            {{
              is_free(slotProps.callback.row.is_free)
            }}
          </el-tag>
        </template> -->
        <template v-slot:operation="slotProps">
           <el-tooltip class="item" effect="dark" :content="$t('btnTip').edit" placement="top">
            <el-button
              @click="handleClick('edit',slotProps.callback.row)"
              icon="el-icon-edit-outline"
              type="primary"
              size="mini"
            ></el-button>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$t('btnTip').delete"
            placement="top"
          >
            <el-button
              size="mini"
              type="danger"
              @click="del(slotProps.callback.row.id)"
              >{{ $t("btnTip").delete }}</el-button
            >
          </el-tooltip>
        </template>
      </my-table>
      <page
        :total="list_data.total"
        :page_size.sync="pageSize"
        :page.sync="page"
      />
    </el-card>
  </div>
</template>
<script>
import { mixin_list } from "@/mixins";
import page from "@/components/page";
import myTable from "@/components/table";
import { chapterList, deleteChapter } from "@/api/api";
export default {
  name: "chapterList",
  mixins: [mixin_list(chapterList)],
  components: {
    myTable,
    page,
  },
  data() {
    return {
      filter: {
        search: "",
        book:this.$route.query.id
      },
      columns: [
        {
          label: "ID",
          sortable: true,
          prop: "id",
          width: 80,
        },
        {
          label: this.$t("chapterList.update_time"),
          sortable: true,
          prop: "update_time",
        },
        {
          label: this.$t("chapterList.number"),
          sortable: true,
          prop: "number",
        },
        {
          label: this.$t("chapterList.title"),
          sortable: true,
          prop: "title",
        },
        // {
        //   label: this.$t("chapterList.is_free"),
        //   sortable: true,
        //   prop: "is_free",
        //   slot: "is_free"
        // },
        {
          label: this.$t("operation"),
          prop: "",
          width: 300,
          slot: "operation",
        },
      ],
    }
  },
  computed: {
    id() {
      return Number.isNaN(Number(this.$route.query.id))
        ? undefined
        : Number(this.$route.query.id);
    }
  },
  methods: {
    // is_free(is_free){
    //   switch(is_free){
    //     case 0:
    //       return this.$t('chapterList.is_free0')
    //     case 1:
    //       return this.$t('chapterList.is_free1')
    //   }
    // },
    // is_freeTag(is_freeTag){
    //   switch(is_freeTag){
    //     case 1:
    //       return 'success'
    //     case 0:
    //       return 'info'
    //   }
    // },
    async handleClick(type, data) {
      switch (type) {
        case "add":
          this.$router.push(`/serialManagement/serialList/chapterList/edit?book_id=${this.id}`)
          break;
        case "edit":
          this.$router.push(`/serialManagement/serialList/chapterList/edit?id=${data.id}&book_id=${this.id}`)
          break;
      }
    },
    async del(id) {
      this.$confirm(this.$t('chapterList').sureDeleteChapter, this.$t('tips'), {
        confirmButtonText: this.$t('btnTips').submit,
        cancelButtonText: this.$t('btnTips').cancel,
        type: 'warning'
      }).then(async () => {
        let res = await deleteChapter(id)
        this.get_list()
      }).catch({
      })
    },
  },
};
</script>
<style lang="scss" scoped>
.span + .span::before{
  content:'/'
}
</style>